<h2 i18n="@@DialogGenericErrorCaption">
  <mat-icon style="vertical-align: middle">error</mat-icon>&nbsp;Attenzione</h2>
<p i18n="@@DialogGenericErrorText">
  Si è verificato un problema, contattare il servizio clienti
</p>
<div style="margin-top: 10px; text-align: right">
  <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose">Chiudi</button>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/generic-error-dialog/generic-error-dialog.html